import { FC, useMemo } from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { useGiveawayContext } from '../../context/GiveawayContext'

interface Props {
  isFooter?: boolean
}

const LOGO_SIZES: Record<'main' | 'footer', string> = {
  main: 'w-[282px] h-[48px]',
  footer: 'w-[152px] h-[40px]',
}

export const GiveawayLogo: FC<Props> = ({ isFooter }) => {
  const { content } = useGiveawayContext()

  const logoUrl = useMemo(() => {
    if (isFooter && typeof content.footerLogoUrl === 'string') {
      return content.footerLogoUrl
    }
    return content.logoUrl || ''
  }, [content.footerLogoUrl, content.logoUrl, isFooter])

  const sizeClass = LOGO_SIZES[isFooter ? 'footer' : 'main']

  return (
    <div className={classNames('relative mx-auto shrink-0 md:mx-0', sizeClass, isFooter && '!mx-0')}>
      <Image alt="logo" src={logoUrl} fill className="object-contain md:object-left" />
    </div>
  )
}
